import PropTypes from 'prop-types'

/**
 * Render an individual limit
 */
function Limit({ limit }) {
  const { unit, value } = limit

  switch (unit) {
    case 'USD':
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      }).format(value)
    case 'USD_cents':
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 2,
        minimumFractionDigits: 0,
      }).format(value / 100)
    case 'day':
    case 'days':
      return value + (parseInt(value) > 1 ? ' days' : 'day')
    case 'month':
    case 'months':
      return value + (parseInt(value) > 1 ? ' months' : 'month')
    case 'percentage':
      return new Intl.NumberFormat('en-US', {
        style: 'percent',
        maximumFractionDigits: 2,
        minimumFractionDigits: 0,
      }).format(value / 100)
    default:
      return value.replace(/_/g, ' ');
  }
}

Limit.propTypes = {
  limit: PropTypes.object,
}

export default Limit
